'use client';

import { useEffect, useState } from 'react';
import { Button, Image } from 'react-bootstrap';
import './scrollToTopButton.scss';

export default function ScrollToTopButton() {
  const [isVisible, setIsVisible] = useState(false);
  const [isFooterVisible, setIsFooterVisible] = useState(false);
  const [isNearBottom, setIsNearBottom] = useState(false);

  useEffect(() => {
    const footerEl = document.querySelector('footer');

    if (!footerEl) {
      return undefined;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        setIsFooterVisible(entries[0]?.isIntersecting ?? false);
      },
      { threshold: 0.1 },
    );

    observer.observe(footerEl);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 320);

      const doc = document.documentElement;
      const remaining =
        doc.scrollHeight - (window.scrollY + window.innerHeight);
      setIsNearBottom(remaining <= 160);
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <Button
      className={`scroll-to-top position-fixed rounded-circle shadow-lg d-flex align-items-center justify-content-center p-3 ${
        isVisible && !isFooterVisible && !isNearBottom ? 'show opacity-80' : ''
      }`.trim()}
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      variant="primary"
      aria-label="Scroll to top"
    >
      <Image
        src="/icons/back.png"
        alt=""
        width="22"
        height="22"
        className="rotate-90"
      />
    </Button>
  );
}
